import moment from 'moment';
export default {
	resultList: [],
	graphList: [],
	pgsStPcCdList: [], //검사상태
	partClCdList: [], //유형
	tymaList: [],
	maxCnt: 0,
	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO(),
	partCkuScrId: '' //부품검사 화면이동 SCRID정보
};

function SEARCH_PARAMS() {
	return {
		strDt: moment().format('YYYY'),
		period: 'month',
		partNo: '',
		cofCd: '',
		tymaCd: '',
		userName: '',
		userId: '',
		pgsStCd: '',
		partClCd: ''
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}
export { SEARCH_PARAMS, PAGING_INFO };
